import ListCommunityTeamsUI from "./components/ListCommunityTeamsUI.js";

const ListCommunityTeams = ({ viewType }) => {
  return (
    <>
      <ListCommunityTeamsUI viewType={viewType} />
    </>
  );
};

export default ListCommunityTeams;
